const InboxIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.9877 9.14828C19.0098 8.96018 18.9848 8.76852 18.9072 8.58898L15.3447 0.631972C15.1723 0.247944 14.7897 0 14.3694 0H4.63114C4.21006 0 3.82817 0.247944 3.65575 0.631972L0.0933352 8.58898C0.0135372 8.76852 -0.0106872 8.96018 0.0113997 9.14828C0.00712483 9.18746 0 9.22309 0 9.26228V14.9037C0 15.4936 0.478076 15.9724 1.06872 15.9724H17.9311C18.521 15.9724 18.9998 15.4936 18.9998 14.9037V9.26228C18.9998 9.22309 18.9934 9.18746 18.9877 9.14828ZM12.4093 12.41H6.59047V7.95701H2.71812L5.32367 2.13745H13.6775L16.2824 7.95701H12.4093V12.41Z" fill={color} />
  </svg>
);

const ContactsIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 22V20H18V22H2ZM2 2V0H18V2H2ZM10 12C10.8333 12 11.5417 11.7083 12.125 11.125C12.7083 10.5417 13 9.83333 13 9C13 8.16667 12.7083 7.45833 12.125 6.875C11.5417 6.29167 10.8333 6 10 6C9.16667 6 8.45833 6.29167 7.875 6.875C7.29167 7.45833 7 8.16667 7 9C7 9.83333 7.29167 10.5417 7.875 11.125C8.45833 11.7083 9.16667 12 10 12ZM2 19C1.45 19 0.979167 18.8042 0.5875 18.4125C0.195833 18.0208 0 17.55 0 17V5C0 4.45 0.195833 3.97917 0.5875 3.5875C0.979167 3.19583 1.45 3 2 3H18C18.55 3 19.0208 3.19583 19.4125 3.5875C19.8042 3.97917 20 4.45 20 5V17C20 17.55 19.8042 18.0208 19.4125 18.4125C19.0208 18.8042 18.55 19 18 19H2ZM3.75 17H16.25C15.5 16.0667 14.5917 15.3333 13.525 14.8C12.4583 14.2667 11.2833 14 10 14C8.71667 14 7.54167 14.2667 6.475 14.8C5.40833 15.3333 4.5 16.0667 3.75 17Z" fill={color} />
  </svg>
);

const AgentsIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 12V10.8C0 10.2667 0.125 9.78333 0.375 9.35C0.625 8.91667 0.966667 8.58333 1.4 8.35C2.33333 7.85 3.29167 7.47917 4.275 7.2375C5.25833 6.99583 6.26667 6.875 7.3 6.875C8.33333 6.875 9.34167 6.99583 10.325 7.2375C11.3083 7.47917 12.2667 7.85 13.2 8.35C13.6333 8.58333 13.975 8.91667 14.225 9.35C14.475 9.78333 14.6 10.2667 14.6 10.8V12H0ZM16.2 12V10.6C16.2 9.93333 16.0083 9.30833 15.625 8.725C15.2417 8.14167 14.7 7.65 14 7.25C14.7667 7.36667 15.4917 7.5625 16.175 7.8375C16.8583 8.1125 17.4833 8.45 18.05 8.85C18.6167 9.25 19.0583 9.69167 19.375 10.175C19.6917 10.6583 19.85 11.15 19.85 11.65V12H16.2ZM7.3 6C6.41667 6 5.66667 5.69167 5.05 5.075C4.43333 4.45833 4.125 3.70833 4.125 2.825C4.125 1.94167 4.43333 1.19167 5.05 0.575C5.66667 -0.0416667 6.41667 -0.35 7.3 -0.35C8.18333 -0.35 8.93333 -0.0416667 9.55 0.575C10.1667 1.19167 10.475 1.94167 10.475 2.825C10.475 3.70833 10.1667 4.45833 9.55 5.075C8.93333 5.69167 8.18333 6 7.3 6ZM16.6 2.825C16.6 3.70833 16.2917 4.45833 15.675 5.075C15.0583 5.69167 14.3083 6 13.425 6C13.2583 6 13.0583 5.98333 12.825 5.95C12.5917 5.91667 12.3917 5.88333 12.225 5.85C12.6583 5.35 12.9833 4.79167 13.2 4.175C13.4167 3.55833 13.525 2.90833 13.525 2.225C13.525 1.54167 13.4167 0.891667 13.2 0.275C12.9833 -0.341667 12.6583 -0.9 12.225 -1.4C12.4583 -1.46667 12.6833 -1.50833 12.9 -1.525C13.1167 -1.54167 13.3083 -1.55 13.475 -1.55C14.3583 -1.55 15.1083 -1.24167 15.725 -0.625C16.3417 -0.00833333 16.65 0.741667 16.65 1.625L16.6 2.825Z" fill={color} />
  </svg>
);

const BillingsIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.9877 9.14828C19.0098 8.96018 18.9848 8.76852 18.9072 8.58898L15.3447 0.631972C15.1723 0.247944 14.7897 0 14.3694 0H4.63114C4.21006 0 3.82817 0.247944 3.65575 0.631972L0.0933352 8.58898C0.0135372 8.76852 -0.0106872 8.96018 0.0113997 9.14828C0.00712483 9.18746 0 9.22309 0 9.26228V14.9037C0 15.4936 0.478076 15.9724 1.06872 15.9724H17.9311C18.521 15.9724 18.9998 15.4936 18.9998 14.9037V9.26228C18.9998 9.22309 18.9934 9.18746 18.9877 9.14828ZM12.4093 12.41H6.59047V7.95701H2.71812L5.32367 2.13745H13.6775L16.2824 7.95701H12.4093V12.41Z" fill={color} />
  </svg>
);



const SettingsIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.6523 7.93915L16.2112 7.54015C16.0683 7.05028 15.8729 6.5794 15.6284 6.13373L17.0534 4.10278C17.1687 3.9388 17.1488 3.71535 17.0072 3.57326L15.4008 1.96775C15.2575 1.82484 15.032 1.80625 14.8676 1.92479L12.8672 3.3626C12.4174 3.11395 11.9424 2.91652 11.4496 2.77319L11.0238 0.342002C10.9891 0.144566 10.8177 0 10.6169 0H8.34517C8.14278 0 7.97013 0.146631 7.9375 0.346545L7.54263 2.76451C7.04697 2.90702 6.57114 3.10239 6.12299 3.34774L4.12798 1.92273C3.96317 1.80501 3.73889 1.82401 3.59556 1.96651L1.99005 3.57202C1.84838 3.71369 1.82855 3.93674 1.94379 4.10072L3.34774 6.10936C3.09784 6.56164 2.89875 7.04036 2.75378 7.5385L0.345306 7.93956C0.146218 7.97261 0 8.14526 0 8.34683V10.6186C0 10.8189 0.14374 10.9903 0.340763 11.0254L2.74923 11.4525C2.89338 11.9494 3.09247 12.4281 3.34319 12.8817L1.9219 14.8696C1.8046 15.0336 1.82318 15.2587 1.96568 15.4021L3.57161 17.0092C3.71328 17.1509 3.93674 17.1707 4.10072 17.0555L6.11225 15.6466C6.56371 15.8948 7.04078 16.0918 7.53519 16.2348L7.93832 18.6556C7.97096 18.8543 8.1432 19.0001 8.34517 19.0001H10.6169C10.8173 19.0001 10.9887 18.8564 11.0234 18.6593L11.455 16.2265C11.9502 16.0807 12.4248 15.8824 12.8717 15.6338L14.8977 17.0551C15.0621 17.1711 15.2852 17.1509 15.4273 17.0092L17.0332 15.4021C17.1761 15.2587 17.1947 15.0328 17.0761 14.8684L15.6313 12.8622C15.8762 12.4162 16.0708 11.9445 16.2125 11.4546L18.6569 11.0254C18.8547 10.9907 18.9984 10.8189 18.9984 10.6186V8.34683C18.9989 8.14443 18.8522 7.97178 18.6523 7.93915ZM9.49922 12.3914C7.90239 12.3914 6.6079 11.0969 6.6079 9.50005C6.6079 7.90322 7.90239 6.60873 9.49922 6.60873C11.0961 6.60873 12.3905 7.90322 12.3905 9.50005C12.3905 11.0969 11.0961 12.3914 9.49922 12.3914Z" fill={color} />
  </svg>
);

const EditIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 17.2499V20.9999H6.75L17.815 9.93494L14.065 6.18494L3 17.2499ZM20.705 7.04494C21.095 6.65494 21.095 6.01994 20.705 5.62994L18.37 3.29494C17.98 2.90494 17.345 2.90494 16.955 3.29494L15.125 5.12494L18.875 8.87494L20.705 7.04494Z" fill={color} />
  </svg>
);

const DeleteIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 19C6 20.105 6.895 21 8 21H16C17.105 21 18 20.105 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" fill={color} />
  </svg>
);

const ExportIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 16V7.85L8.4 10.45L7 9L12 4L17 9L15.6 10.45L13 7.85V16H11ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z" fill={color} />
  </svg>
);

const ViewIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill={color} />
  </svg>
);

const ExpandMoreIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z" fill={color} />
  </svg>
);

const ExpandLessIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z" fill={color} />
  </svg>
);

const ArrowForwardIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill={color} />
  </svg>
);

const CalendarIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z" fill={color} />
  </svg>
);

const UploadIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z" fill={color} />
  </svg>
);

const InfoIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill={color} />
  </svg>
);

const CancelIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z" fill={color} />
  </svg>
);

const AddIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill={color} />
  </svg>
);

const MessageOutgoingIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_outgoing)">
      <path 
        d="M3.50344 2.62566C3.50344 3.10964 3.89514 3.50134 4.37913 3.50134H9.26819L2.00637 10.7509C1.66389 11.0933 1.66389 11.6491 2.00637 11.9936C2.34885 12.3361 2.90666 12.3361 3.24915 11.9936L10.5007 4.73386V9.62292C10.5007 10.1069 10.8924 10.4986 11.3764 10.4986C11.8604 10.4986 12.2521 10.1069 12.2521 9.62292V2.62566C12.2521 2.14167 11.8604 1.74998 11.3764 1.74998H4.37708C3.89514 1.74998 3.50344 2.14167 3.50344 2.62566Z" 
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_outgoing">
        <rect width="10.5" height="10.5" fill="white" transform="matrix(0 -1 1 0 1.75 12.25)"/>
      </clipPath>
    </defs>
  </svg>
);

const MessageIncomingIcon = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_incoming)">
      <path 
        d="M10.4966 11.3743C10.4966 10.8904 10.1049 10.4987 9.62087 10.4987H4.73181L11.9936 3.24915C12.3361 2.90666 12.3361 2.3509 11.9936 2.00637C11.6511 1.66389 11.0933 1.66389 10.7509 2.00637L3.49929 9.26614V4.37708C3.49929 3.89309 3.10759 3.50139 2.62361 3.50139C2.13962 3.50139 1.74792 3.89309 1.74792 4.37708V11.3743C1.74792 11.8583 2.13962 12.25 2.62361 12.25H9.62292C10.1049 12.25 10.4966 11.8583 10.4966 11.3743Z" 
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_incoming">
        <rect width="10.5" height="10.5" fill="white" transform="matrix(0 1 -1 0 12.25 1.75)"/>
      </clipPath>
    </defs>
  </svg>
);

const iconMap = {
  inbox: InboxIcon,
  contacts: ContactsIcon,
  agents: AgentsIcon,
  billings: BillingsIcon,
  settings: SettingsIcon,
  edit: EditIcon,
  delete: DeleteIcon,
  export: ExportIcon,
  view: ViewIcon,
  expand_more: ExpandMoreIcon,
  expand_less: ExpandLessIcon,
  arrow_forward: ArrowForwardIcon,
  calendar: CalendarIcon,
  upload: UploadIcon,
  info: InfoIcon,
  cancel: CancelIcon,
  add: AddIcon,
  message_outgoing: MessageOutgoingIcon,
  message_incoming: MessageIncomingIcon,
};

const Icon = ({ name, color = '#9CA8BB', width = 20, height = 20, className = '' }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <IconComponent
      color={color}
      width={width}
      height={height}
      className={className}
    />
  );
};

export default Icon;
